export default __webpack_public_path__ + "static/media/icon-camera.998e5bf3.svg";